import { render, staticRenderFns } from "./FttbPricing.vue?vue&type=template&id=237fdcb1&scoped=true&"
import script from "./FttbPricing.vue?vue&type=script&lang=js&"
export * from "./FttbPricing.vue?vue&type=script&lang=js&"
import style0 from "./FttbPricing.vue?vue&type=style&index=0&id=237fdcb1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237fdcb1",
  null
  
)

export default component.exports